module.exports = __webpack_public_path__ + "fonts/Alga-LightItalic.4703ce6c.woff2";